<div class="eligibility-view">
    <eas-eligibility-view-rule [eligibility]="eligibilityRule()"></eas-eligibility-view-rule>
</div>
